/* eslint-disable */
import type { Permissions } from "api/permission/getpermission";

export const checkPermission = (
  permissions: Permissions | null,
  path: string
): boolean => {
  if (!permissions) return false;
  const parts = path.split(".");
  console.log(permissions, "Checking permission for path:", path);
  let cur: any = permissions;
  for (const p of parts) {
    if (cur == null) return false;
    cur = cur[p];
  }
  return Boolean(cur);
};
